<div [ngClass]="{ 'question m-0': !answerDisplay, question: 'answerDisplay' }">
  <div>{{ question }}</div>
  @if (!answerDisplay) {
    <span (click)="answerDisplay = true" class="icon-more">+</span>
  }
  @if (answerDisplay) {
    <span (click)="answerDisplay = false" class="icon-more">-</span>
  }
</div>
@if (answerDisplay) {
  <div class="answer"><ng-content></ng-content></div>
}
